import { md5 } from '@/util/md5'

const setLocalFun = function (key, value) {
    // sessionStorage
    localStorage.setItem(key, value)
}
const getLocalFun = function (key) {
    return localStorage.getItem(key)
}
const removeLocalFun = function (key) {
    return localStorage.removeItem(key)
}
function supFormatTime(st){
    if(String(st).length<2){
        st=`0${st}`
    }
    return st
}
// 获取当前时间
function formatTime(time) {
    if (!time) {
        time = new Date()
    }
    let Y=time.getFullYear();
    let M=supFormatTime(time.getMonth()+1);
    let D=supFormatTime(time.getDate());
    let h=supFormatTime(time.getHours());
    let m=supFormatTime(time.getMinutes());
    let s=supFormatTime(time.getSeconds());
    let date=`${Y}-${M}-${D} ${h}:${m}:${s}`;
    return date
}
// 获取当前时间的yyyyMMddHHmmss格式字符串，作为接口入参中的timestamp字段（后端校验其与服务器时间的偏差）
function formatTimeCompact(time) {
    if (!time) {
        time = new Date()
    }
    let Y=time.getFullYear();
    let M=supFormatTime(time.getMonth()+1);
    let D=supFormatTime(time.getDate());
    let h=supFormatTime(time.getHours());
    let m=supFormatTime(time.getMinutes());
    let s=supFormatTime(time.getSeconds());
    return `${Y}${M}${D}${h}${m}${s}`
}
// 日期转时间戳
// 支持 2022-09-02 12:00 也支持 2022-09-02 12:00:00
function formatDateToTime(temp) {
    var arr= []
    temp.forEach(item => {
        var string
        var date1 = item.replace(/-/g, '/');  //开始时间
        if (date1.split(' ')[1].length == 5) {
            string = date1.split(' ')[1] + ':00'
            string = new Date(date1.split(' ')[0] + ' ' + string).getTime();
        }
        arr.push(string)
    })
    return arr;
}

// 获取传入时间的前后时间
// common.getDate('2022-09-02',-0,'day')
function getDate(date, AddDayCount = 0, str = 'day',time = 'yyyy-MM-dd HH:mm:ss,w',mark = '-') {
    // time为false时，str不能传时分秒
    // 拼接字符只支持‘-’ + ‘/
    if (!date) {
        date = new Date()
    }	
    if (typeof date !== 'object') {
        date = date.replace(/-/g, '/')
    }
    const dd = new Date(date)
    
    switch (str) {
        case 'second':
                dd.setSeconds((dd.getSeconds() + AddDayCount))
                break
        case 'minute':
            dd.setMinutes((dd.getMinutes() + AddDayCount)) // 获取AddDayCount天后的日期
            break
        case 'hours':
                dd.setHours(dd.getHours() + AddDayCount)
                break
        case 'day':
            dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
            break
        case 'month':
            if (dd.getDate() === 31) {
                dd.setDate(dd.getDate() + AddDayCount)
            } else {
                dd.setMonth(dd.getMonth() + AddDayCount) // 获取AddDayCount天后的日期
            }
            break
        case 'year':
            dd.setFullYear(dd.getFullYear() + AddDayCount) // 获取AddDayCount天后的日期
            break
    }
    
    let week = '';
    let arr = ['日', '一', '二', '三', '四', '五', '六']
    week = arr[dd.getDay()]
    let opt  = {
                "y+": String(dd.getFullYear()),
                "M+": String(dd.getMonth() + 1),
                "d+": String(dd.getDate()),
                "H+": String(dd.getHours()),
                "m+": String(dd.getMinutes()),
                "s+": String(dd.getSeconds()),
                "w+": week,
        }
    for (let k in opt) {
        let reg = new RegExp(k);
        let arr = time.match(reg);
        if (arr) {
                let leg = arr[0].length;
                time = time.replace(reg, opt[k].padStart(leg, "0"))
        }
    }
    
     return time;
     
}
// 获取距离日期时间戳
function getDateTime(date, AddDayCount = 0, str = 'day') {
    // time为false时，str不能传时分秒
    // 拼接字符只支持‘-’ + ‘/
    if (!date) {
        date = new Date()
    }	
    if (typeof date !== 'object') {
        date = date.replace(/-/g, '/')
    }
    const dd = new Date(date)
 
    switch (str) {
        case 'second':
                dd.setSeconds((dd.getSeconds() + AddDayCount))
                break
        case 'minute':
            dd.setMinutes((dd.getMinutes() + AddDayCount)) // 获取AddDayCount天后的日期
            break
        case 'hours':
                dd.setHours(dd.getHours() + AddDayCount)
                break
        case 'day':
            dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
            break
        case 'month':
            if (dd.getDate() === 31) {
                dd.setDate(dd.getDate() + AddDayCount)
            } else {
                dd.setMonth(dd.getMonth() + AddDayCount) // 获取AddDayCount天后的日期
            }
            break
        case 'year':
            dd.setFullYear(dd.getFullYear() + AddDayCount) // 获取AddDayCount天后的日期
            break
    }
    
  
    let opt  = {
            "y": String(dd.getFullYear()),
            "M": String(dd.getMonth() + 1),
            "d": String(dd.getDate()),
            "H": String(dd.getHours()),
            "m": String(dd.getMinutes()),
            "s": String(dd.getSeconds()),
    }
   
   
    return  new Date(opt.y +'-'+opt.M +'-'+opt.d +' '+opt.H +':'+opt.m +':'+opt.s).getTime()
     
}

	//随机字符串
function randomString(len) {
    len = len || 32;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = $chars.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        // console.log(i)
    }
    return pwd;
}


// 生成接口签名。与后端MyMD5Util.sortAndSign保持同一规则：
// 值为空/null的字段以及sign、key不参与签名；按参数名字典序排序；拼接为 k1=v1&k2=v2&key=密钥；MD5后转大写。
function genSign(params, signKey) {
    const keys = []
    Object.keys(params).forEach(k => {
        const v = params[k]
        if (k !== 'sign' && k !== 'key' && v !== null && v !== undefined && v !== '') {
            keys.push(k)
        }
    })
    keys.sort()
    let str = ''
    keys.forEach(k => {
        str += k + '=' + params[k] + '&'
    })
    str += 'key=' + signKey
    return md5(str).toUpperCase()
}


export const util={
    setLocalFun,getLocalFun,removeLocalFun,formatTime,formatTimeCompact,genSign,getDate,getDateTime,randomString,formatDateToTime,
}
export default {
    install(Vue){
        Vue.prototype.$util=util
    }
}
